// extracted by mini-css-extract-plugin
var _1 = "CalendarGridWeekAllDaySpan-moduleCalendarGridWeekAllDaySpan__Uf9Bq";
export { _1 as "CalendarGridWeekAllDaySpan" }
